import axios from 'axios';

const API_HOST = process.env.REACT_APP_API_BASE_PATH;

export const getDepositsData = params =>
  axios.get(`${API_HOST}/deposits`, { params, withCredentials: true });

export const downloadDepositData = params =>
  axios.get(`${API_HOST}/deposits/download`, { params, withCredentials: true });

export const editDepositRegisterData = (shopId, params) =>
  axios.put(`${API_HOST}/deposits/${shopId}`, params, {
    withCredentials: true
  });

export const getDepositCurrentMonthGroupData = params =>
  axios.get(`${API_HOST}/groups/deposit/current-month`, {
    params,
    withCredentials: true
  });

export const getDepositByMonthGroupData = (month, params) =>
  axios.get(`${API_HOST}/groups/deposit/month/${month}`, {
    params,
    withCredentials: true
  });

export const getDepositDetailCurrentMonthGroupData = params =>
  axios.get(`${API_HOST}/groups/deposit/detail/current-month`, {
    params,
    withCredentials: true
  });

export const getDepositDetailByMonthGroupData = (month, params) =>
  axios.get(`${API_HOST}/groups/deposit/detail/${month}`, {
    params,
    withCredentials: true
  });

export const downloadDepositDetailCurrentMonthData = params =>
  axios.get(`${API_HOST}/groups/deposit/detail/current-month/download`, {
    params,
    withCredentials: true
  });

export const downloadDepositDetailByMonthData = (month, params) =>
  axios.get(`${API_HOST}/groups/deposit/detail/${month}/download`, {
    params,
    withCredentials: true
  });

export const sendMailDepositDetailMonthData = month =>
  axios.post(`${API_HOST}/groups/deposit/send-email/${month}`, null, {
    withCredentials: true
  });

export const sendMailDepositDetailByShopMonthData = (month, shopId) =>
  axios.post(
    `${API_HOST}/groups/deposit/send-email/${month}/shop/${shopId}/`,
    null,
    {
      withCredentials: true
    }
  );
